import script from "./marketing-email-designer-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./marketing-email-designer-modal.vue?vue&type=script&setup=true&lang=ts"

import "./marketing-email-designer-modal.vue?vue&type=style&index=0&id=190e0210&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190e0210"]])

export default __exports__